var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"pa-0":""}},[_c('v-alert',{attrs:{"value":_vm.AlertNG.Alert,"type":"warning"}},[_vm._v(_vm._s(_vm.AlertNG.Msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }